import { render, staticRenderFns } from "./ParametrizacaoContratoForm.vue?vue&type=template&id=ba196c4c&lang=html"
import script from "./ParametrizacaoContratoForm.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoContratoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports